<template>
  <div class="my-sales-page mt-4">
    <app-page-header title="Resumo de Vendas"></app-page-header>

    <div class="container">
      <div class="report">
        <h1 style="display: block;">
          Sem informações suficientes para este relatório.
        </h1>
      </div>
      <div class="listing">
        <div class="row search-fields">
          <b-field class="col-md-3 col-sm-12" label="Código EAN">
            <b-input v-model="filters.ean_code" @input="loadSalesDebounced" />
          </b-field>

          <b-field class="col-md-3 col-sm-12" label="Família">
            <b-select
              id="family"
              placeholder="Selecionar"
              v-model="filters.family"
              @input="loadSales"
            >
              <option :value="undefined">Todas</option>
              <option
                v-for="family in families"
                :value="family"
                :key="family"
                >{{ family }}</option
              >
            </b-select>
          </b-field>

          <app-autocomplete
            class="col-md-3 col-sm-12"
            label="Produto"
            placeholder="Selecionar"
            :searchFunction="searchProducts"
            :resouceIdFunction="searchProductById"
            v-model="filters.product_id"
            field="name"
            @selected="loadSales"
          />

          <b-field class="col-md-3 col-sm-12" label="Mês">
            <b-datepicker
              type="month"
              placeholder="Clique para selecionar..."
              icon="calendar-today"
              trap-focus
              v-model="filters.date"
              @input="loadSales"
            />
          </b-field>
        </div>
        <div class="sales-table">
          <b-table
            :data="sales"
            :loading="isLoadingTable"
            paginated
            backend-pagination
            :total="total"
            :per-page="perPage"
            @page-change="onPageChange"
            aria-next-label="Próxima Página"
            aria-previous-label="Página Anterior"
            aria-page-label="Página"
            aria-current-label="Página Atual"
          >
            <template slot-scope="props">
              <b-table-column field="created_at" label="Data" numeric>{{
                props.row.created_at | date('LL')
              }}</b-table-column>
              <b-table-column field="from" label="Código EAN">{{
                props.row.ean_code
              }}</b-table-column>
              <b-table-column field="from" label="Família">{{
                props.row.product_family
              }}</b-table-column>
              <b-table-column field="from" label="Produto">{{
                props.row.product_description
              }}</b-table-column>
              <b-table-column field="from" label="Qtd" numeric>{{
                props.row.quantity
              }}</b-table-column>
              <b-table-column field="from" label="Pontos">{{
                props.row.points
              }}</b-table-column>
              <b-table-column field="type" label="Tipo">{{
                props.row.type
              }}</b-table-column>
            </template>
            <template slot="empty">
              <section>
                <h1 id="no-results">Sem resultados.</h1>
              </section>
            </template>
          </b-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProductService from '@/services/product.service.js';
import SaleService from '@/services/sale.service.js';
import { ClientTypeLabel } from '@/enums/ClientTypeEnum.js';
import debounce from 'lodash/debounce';

export default {
  name: 'my-sales-page',
  data: () => {
    return {
      sales: [],
      families: [],
      filters: {
        family: null,
        product_id: null,
        ean_code: null,
        date: null,
      },
      isLoadingTable: null,
      page: null,
      perPage: 10,
      total: null,
    };
  },
  methods: {
    loadSales() {
      this.isLoadingTable = true;
      SaleService.getByClient({
        page: this.page,
        perPage: this.perPage,
        ...this.filters,
      })
        .then((response) => {
          this.sales = response.data.data.map((sale) => {
            sale.type = ClientTypeLabel.get(sale.type);
            return sale;
          });
        })
        .finally(() => {
          this.isLoadingTable = false;
        });
    },
    loadSalesDebounced: debounce(function () {
      this.loadSales();
    }, 400),
    loadFamilies() {
      ProductService.getFamilies().then((response) => {
        this.families = response.data;
      });
    },
    onPageChange(page) {
      this.page = page;
      this.loadSales();
    },
    searchProducts: (term) => ProductService.search({ term, paginate: false }),
    searchProductById: ProductService.getId,
  },
  mounted() {
    this.loadFamilies();
    this.loadSales();
  },
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  margin: auto;
}

h1 {
  font-size: 1.5em;
  font-weight: bold;
  text-align: center;
}

.search-fields {
  background: var(--color-light-grey);
  margin-top: 4em;
  padding: 1em 2em;
  border-radius: 1em;
}

#no-results {
  margin-top: 2em;
}

@media (max-width: 992px) {
  h1 {
    margin-bottom: 2em;
  }

  .search-fields {
    margin: 0;
    padding: 1em;
    margin-bottom: 1em;
  }
}
</style>
